import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../common.service';
import { ToastrService } from 'ngx-toastr';
import { DefaultComponent } from '../../layout/default/default.component';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';

declare var $: any;
@Component({
  selector: 'app-bollywood-list',
  templateUrl: './bollywood-list.component.html',
  styleUrls: ['./bollywood-list.component.css']
})
export class BollywoodListComponent implements OnInit {
  filter_div = false;
  show_filter_text = true;
  show_multiple_delete_btn = false;
   show_multiple_active_btn = false;
  show_filter_date = false;
  bollywoodList = [];
  display_order_currrent = [];
  display_order_val = [];
  display_order_ids = [];
  news_delete_checkbox = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    public CommonService: CommonService,
    public DefaultComponent: DefaultComponent
  ) {
    this.get_bollywood_news_list();
  }

  get_bollywood_news_list() {
    this.DefaultComponent.loaderShow();
    var parameter = { 'entry_date': localStorage.getItem('EntryDate'),'is_imported':  'yes'  };
    this.CommonService.GetBollywoodNewsList(parameter).subscribe((data) => {
      if (data.status) {
        this.bollywoodList = data.news_list;
      } else {
        if (data.token_expire) {
          localStorage.removeItem('login_token');
          this.router.navigate(['/']);
        }
      }
      this.DefaultComponent.loaderHide();
    });
  }
  showFilterDiv(e) {
    var th = this;
    if (e.target.value == 'title') {
      th.show_filter_text = true;
      th.show_filter_date = false;
    } else {
      th.show_filter_text = false;
      th.show_filter_date = true;
      th.DefaultComponent.loaderShow();
      setTimeout(function () {
        $('#datepicker1').datepicker({
          format: "dd-mm-yyyy",
          autoclose: true,
          orientation: "top",
          todayHighlight: true,
        })
        th.DefaultComponent.loaderHide();
      }, 500);
    }
  }
  add_delete_checkbox(e, id) {
    if (this.news_delete_checkbox.includes(id)) {
      var index = this.news_delete_checkbox.indexOf(id);
      this.news_delete_checkbox.splice(index, 1);
    }
    if (e.target.checked == true) {
      this.news_delete_checkbox.push(id);
    }
    if (this.news_delete_checkbox.length > 0) {
      this.show_multiple_delete_btn = true;
    } else {
      this.show_multiple_delete_btn = false;
    }
  }
  delete_multiple_news() {
    Swal.fire({
      title: 'Are you sure to delete this news?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      confirmButtonText: "Yes, delete it!",
      showCancelButton: true,
      cancelButtonText: "No, cancel!",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        var th = this;
        var routers = this.router;
        this.DefaultComponent.loaderShow();
        var parameter = { 'del_ids': th.news_delete_checkbox, 'news_date': localStorage.getItem('EntryDate') };
        this.CommonService.DeleteBollywoodNews(parameter).subscribe((data) => {
          if (data.status) {
            th.toastr.success(data.message);
            this.news_delete_checkbox = [];
            th.get_bollywood_news_list();
          } else {
            if (data.token_expire) {
              localStorage.removeItem('login_token');
              routers.navigate(['/']);
            } else {
              th.toastr.error(data.message);
            }
          }
          this.DefaultComponent.loaderHide();
        });
      }
    });

  }
activeDeactiveAll(e) {

    if (e.target.checked == true) {
      $(".newsStatus").each(function (a) {
        $(this).prop('checked', true);
      });
      this.show_multiple_active_btn = true;
    } else {
      $(".newsStatus").each(function (a) {
        $(this).prop('checked', false);
      });
      this.show_multiple_active_btn = false;
    }
  }
  update_news_status(e: any, newsId: any) {
    const news_ids: any[] = [];

    $(".newsStatus").each(function () {
      if ($(this).is(":checked")) {
        news_ids.push($(this).val());
      }
    });

    this.show_multiple_active_btn = news_ids.length > 0;

    const totalCheckboxes = $(".newsStatus").length;
    const checkedCheckboxes = $(".newsStatus:checked").length;

    $("#mainCheckbox").prop(
      "checked",
      totalCheckboxes > 0 && totalCheckboxes === checkedCheckboxes
    );
  }
   update_news_noti(e: any, newsId: any) {
     if (e.target.checked == true) {
     Swal.fire({
        title: 'Are you sure to active this news and send notification?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: "Yes, send noti & active it!",
        showCancelButton: true,
        cancelButtonText: "No, cancel!",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          var th = this;
          var routers = this.router;
          this.DefaultComponent.loaderShow();
          var parameter = { 'news_id': newsId, 'table_name': 'tbl_bollywood_news', "prefix": "bollywood", "status": 'yes',news_date: localStorage.getItem('EntryDate') };
          this.CommonService.ActiveNotiNewsImported(parameter).subscribe((data) => {
            if (data.status) {
              th.toastr.success(data.message);
              th.get_bollywood_news_list();
            } else {
              if (data.token_expire) {
                localStorage.removeItem('login_token');
                routers.navigate(['/']);
              } else {
                th.toastr.error(data.message);
              }
            }
            this.DefaultComponent.loaderHide();
          });
        }
      });
     }
  }
  active_all() {
    const news_ids: any[] = [];

    $(".newsStatus").each(function () {
      if ($(this).is(":checked")) {
        news_ids.push($(this).val());
      }
    });

    if (news_ids.length > 0) {
      Swal.fire({
        title: 'Are you sure to active this news?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: "Yes, active it!",
        showCancelButton: true,
        cancelButtonText: "No, cancel!",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          var th = this;
          var routers = this.router;
          this.DefaultComponent.loaderShow();
          var parameter = { 'news_ids': news_ids, 'table_name': 'tbl_bollywood_news', "prefix": "bollywood", "status": 'yes',news_date: localStorage.getItem('EntryDate') };
          this.CommonService.ActiveDeactiveNewsImported(parameter).subscribe((data) => {
            if (data.status) {
              th.toastr.success(data.message);
              th.get_bollywood_news_list();
            } else {
              if (data.token_expire) {
                localStorage.removeItem('login_token');
                routers.navigate(['/']);
              } else {
                th.toastr.error(data.message);
              }
            }
            this.DefaultComponent.loaderHide();
          });
        }
      });
    } else {
      this.toastr.error("Please select at least one news to active.");
    }
  }
  ngOnInit(): void {
  }
}

